import {memo} from 'react';
import Modal from 'react-bootstrap/Modal';
import Classes from './ModalView.module.scss';
import closeIcon from '../../assets/icons/close.svg';

const ModalView = (props: any) => {
    const {
        show,
        handleClose,
        children,
        size,
        additionalClassName = '',
        closeBtnClass,
        closeBtnDisable,
        backDrop
    } = props;
    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop={backDrop || 'static'}
            size={size}
            centered={true}
            contentClassName={`${Classes.modalWrap} ${additionalClassName}`}
            keyboard={false}
        >
            {children}
            {!closeBtnDisable && (
                <button
                    className={`${Classes.modalCloseButton} position-absolute ${closeBtnClass}`}
                    onClick={handleClose}
                >
                    <img
                        src={closeIcon}
                        alt="Close"
                        width={30}
                    />
                </button>
            )}
        </Modal>
    );
};

export default memo(ModalView);